module.exports = require('./helpers/bundle-url').getBundleURL('l2gV3') + "logo-dark.eefe0b7f.svg";